module.exports = __webpack_public_path__ + "img/ineligible.b5db2eb6.png";